
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"width":"24px","height":"24px"},style,staticStyle],
              attrs: Object.assign({"style":"width:24px;height:24px","viewBox":"0 0 640 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M623.1 136.9L340.4 35.7c-6.1-2.47-13.2-3.7-20.4-3.7s-14.3 1.23-21.2 3.68L16.05 136.9C6.438 140.4 0 149.6 0 160s6.438 19.65 16.05 23.09l60.02 21.51c-11.89 15.8-20.26 34.16-24.55 53.95C40.05 263.4 32 274.8 32 288c0 9.953 4.814 18.49 11.94 24.36l-24.83 149C17.48 471.1 25 480 34.89 480h58.22c9.887 0 17.41-8.879 15.78-18.63l-24.83-149C91.19 306.5 96 297.1 96 288c0-10.29-5.174-19.03-12.72-24.89a106.301 106.301 0 0124.94-47.03l190.6 68.23C305.7 286.8 312.8 288 320 288s14.35-1.229 21.21-3.684l282.7-101.2C633.6 179.6 640 170.4 640 160s-6.4-19.6-16.9-23.1zm-298 102.2a14.947 14.947 0 01-10.09.006L175.5 189.2l149.2-45.92c8.453-2.594 13.16-11.55 10.57-20.02-2.594-8.438-11.57-13.27-20.01-10.55L125.2 171.2 93.96 160l220.1-79.12a14.935 14.935 0 0110.09-.006L546 160l-220.9 79.1zm127.2 39.4L464 390.7c0 10.6-49.5 41.3-144 41.3s-144-30.72-144-41.34l11.72-112.1-46.08-16.5-13.51 126.1C128 449.3 224.6 480 320 480s192-30.69 191.9-91.81l-13.51-126.1-46.09 16.41z"}})])
          )
        }
      }
    